import { TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, Tooltip } from "@mui/material";
import {useRef, useEffect} from 'react';
export default function FormBudget(props) {
      // Create ref for first input
      const firstInputRef = useRef(null);

      // Focus on first input when component mounts
      useEffect(() => {
          if (firstInputRef.current) {
              firstInputRef.current.focus();
          }
      }, []); // Empty dependency array means this runs once when component mounts
  
    const formatNumber = (num) => {
        if (!num) return '';
        // Remove any existing commas and non-numeric characters except decimal point
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // Format with commas
        return cleanNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        // Remove commas before saving to state
        const cleanValue = value.replace(/,/g, '');
        const finalValue = cleanValue === '' ? 0 : cleanValue;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: finalValue });
    }

    const onChecked = (e) => {
        const { name, checked } = e.target;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: checked });
    }

    return (
        <>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Budgeted Revenue for the period being reported.  Should be for the same period the actuals are being reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Revenue</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Budgeted Revenue"
                                value={formatNumber(props.selectedFinancial.budgetedRevenue)}
                                onChange={onChange}
                                name='budgetedRevenue'
                                inputRef={firstInputRef}
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Budgeted Cost of Goods Sold (COGS) for the period reported.  Should be for the same period the actuals are being reported. " arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>COGS</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Budgeted COGS"
                                value={formatNumber(props.selectedFinancial.budgetedCOGS)}
                                onChange={onChange}
                                name='budgetedCOGS'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Budgeted Selling, General & Administratve (SG&A) expenses for the period reported.  Should be for the same period the actuals are being reported. " arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Overhead</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Overhead"
                                value={formatNumber(props.selectedFinancial.budgetedOverhead)}
                                onChange={onChange}
                                name='budgetedOverhead'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Budgeted  non-statutory accruals (bonuses, safety, traning, shop burden, etc. ) for the period reported. Enter as a positive number to add Accruals back into profit to normalize across companies. We understand the accounting convention is to have a negative number but not all companies accrue so we add back accruals to normalize profits.  Does not inlcude statutory accruals (e.g. payroll taxes)." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Accrual</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Accrual"
                                value={formatNumber(props.selectedFinancial.budgetedAccrual)}
                                onChange={onChange}
                                name='budgetedAccrual'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Budgeted fiscal year non-recurring increases or decreses to Net Income (i.e. claim settlement, etc.) for the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Adjustments to Net</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.budgetedAdjustmentsToNet)}
                                label="Adjustments to Net"
                                onChange={onChange}
                                name='budgetedAdjustmentsToNet'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Budgeted contributions to ESOP including cash, debt service, repurchase obligations and synthetic stock for the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>ESOP</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="ESOP"
                                value={formatNumber(props.selectedFinancial.budgetedESOP)}
                                onChange={onChange}
                                name='budgetedESOP'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Budgeted accruals for and/or quarterly payments for Taxes for the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Taxes</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="Taxes"
                                value={formatNumber(props.selectedFinancial.budgetedTaxes)}
                                onChange={onChange}
                                name='budgetedTaxes'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Budgeted Paycheck Protection Program (PPP) loans forgiven in the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>PPP</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="PPP"
                                value={formatNumber(props.selectedFinancial.budgetedPPP)}
                                onChange={onChange}
                                name='budgetedPPP'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Budgeted Employee Retention Credits received in the period reported." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>ERC</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                label="ERC"
                                value={formatNumber(props.selectedFinancial.budgetedERC)}
                                onChange={onChange}
                                name='budgetedERC'
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
        </>
    );
}